export const userId = ({ featureFlags }) => featureFlags?.user_id
export const timestamp = ({ featureFlags }) => featureFlags?.timestamp
export const allFlags = ({ featureFlags }) => featureFlags?.flags || {}

export const getFeatureFlag = (state, flagName) =>
  allFlags(state)[flagName] ?? false
